import React, { useState } from "react";
import { Button, Dropdown, message } from "antd";
import {
  DownloadOutlined,
  DownOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  FileWordOutlined,
} from "@ant-design/icons";

const AprExportButtons = ({
  disabled = false,
  onPdf,
  onWord,
  onExcel,
  label = "Download",
}) => {
  const [busy, setBusy] = useState(false);

  const run = async (handler, kind) => {
    if (!handler || busy || disabled) return;
    setBusy(true);
    try {
      await handler();
      message.success(`${kind} download started`);
    } catch (error) {
      console.error(`APR ${kind} export failed:`, error);
      message.error(error?.message || `Could not download ${kind}. Please try again.`);
    } finally {
      setBusy(false);
    }
  };

  const items = [
    onPdf && {
      key: "pdf",
      icon: <FilePdfOutlined />,
      label: "PDF",
      onClick: () => run(onPdf, "PDF"),
    },
    onWord && {
      key: "word",
      icon: <FileWordOutlined />,
      label: "Word",
      onClick: () => run(onWord, "Word"),
    },
    onExcel && {
      key: "excel",
      icon: <FileExcelOutlined />,
      label: "Excel",
      onClick: () => run(onExcel, "Excel"),
    },
  ].filter(Boolean);

  return (
    <Dropdown menu={{ items }} trigger={["click"]} disabled={disabled || busy || items.length === 0}>
      <Button
        type="primary"
        icon={<DownloadOutlined />}
        loading={busy}
        disabled={disabled}
        style={{
          backgroundColor: "#16325a",
          borderColor: "#16325a",
          height: 36,
          fontWeight: 600,
        }}
      >
        {label} <DownOutlined style={{ fontSize: 10, marginLeft: 4 }} />
      </Button>
    </Dropdown>
  );
};

export default AprExportButtons;
